var map = {
	"./fruits_0.csv": 672,
	"./fruits_1.csv": 673,
	"./fruits_10.csv": 674,
	"./fruits_11.csv": 675,
	"./fruits_12.csv": 676,
	"./fruits_13.csv": 677,
	"./fruits_14.csv": 678,
	"./fruits_15.csv": 679,
	"./fruits_16.csv": 680,
	"./fruits_17.csv": 681,
	"./fruits_18.csv": 682,
	"./fruits_19.csv": 683,
	"./fruits_2.csv": 684,
	"./fruits_20.csv": 685,
	"./fruits_21.csv": 686,
	"./fruits_22.csv": 687,
	"./fruits_23.csv": 688,
	"./fruits_24.csv": 689,
	"./fruits_25.csv": 690,
	"./fruits_26.csv": 691,
	"./fruits_27.csv": 692,
	"./fruits_28.csv": 693,
	"./fruits_29.csv": 694,
	"./fruits_3.csv": 695,
	"./fruits_30.csv": 696,
	"./fruits_31.csv": 697,
	"./fruits_32.csv": 698,
	"./fruits_33.csv": 699,
	"./fruits_34.csv": 700,
	"./fruits_35.csv": 701,
	"./fruits_36.csv": 702,
	"./fruits_37.csv": 703,
	"./fruits_38.csv": 704,
	"./fruits_39.csv": 705,
	"./fruits_4.csv": 706,
	"./fruits_40.csv": 707,
	"./fruits_41.csv": 708,
	"./fruits_42.csv": 709,
	"./fruits_43.csv": 710,
	"./fruits_44.csv": 711,
	"./fruits_45.csv": 712,
	"./fruits_46.csv": 713,
	"./fruits_47.csv": 714,
	"./fruits_48.csv": 715,
	"./fruits_49.csv": 716,
	"./fruits_5.csv": 717,
	"./fruits_50.csv": 718,
	"./fruits_51.csv": 719,
	"./fruits_52.csv": 720,
	"./fruits_53.csv": 721,
	"./fruits_6.csv": 722,
	"./fruits_7.csv": 723,
	"./fruits_8.csv": 724,
	"./fruits_9.csv": 725,
	"./fruits_item_list.csv": 726
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits ^\.\/.*\.csv$
// module id = 671
// module chunks = 0